import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { configurarApiClient } from "./utils/apiClient";

const msalInstance = new PublicClientApplication(msalConfig);
// As chamadas à API pegam o token desta instância (sem escopo configurado, seguem sem token)
configurarApiClient(msalInstance);

// Initialize MSAL before rendering to avoid duplicate-instance warning in StrictMode
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
